import React, { FC } from 'react';
import cn from 'classnames';
import { TabItem } from '../types';
import { EngineTheme, useMergeClasses, useTheme } from '../../../../../theme';

interface Props {
	classes?: EngineTheme['Shared']['Tabs'];
	tabs: TabItem[];
	active: number;
	variant?: 'line' | 'lineInvert';
	onChange: (index: number) => void;
}

const Tabs: FC<Props> = ({ classes, tabs, active, variant = 'line', onChange }) => {
	const { Tabs: defaultClasses } = useTheme('Shared');
	const theme = useMergeClasses(defaultClasses, classes);

	return (
		<div className={cn(theme.tabs, theme[variant])} role="tablist">
			{tabs.map(({ label, description }, index) => (
				<div
					key={`${index}-${label}`}
					className={theme.tab}
					role="tab"
					aria-selected={active === index}
					onClick={() => onChange(index)}
				>
					<span className={theme.label}>{label}</span>

					{!!description && <div className={cn(theme.description, classes?.description)}>{description}</div>}

					<span className={cn(theme.underline, classes?.underline)} />
				</div>
			))}
		</div>
	);
};

export default Tabs;
